/**
 * Copyright (C) Boost commerce
 * This file is part of commercial Boost commerce projects
 *
 * This file can not be copied and/or distributed without the express
 * permission of Boost commerce
 *
 * Created on Thu Nov 23 2023 15:26:59
 */
// @flow

import React, { useMemo } from 'react';
import { withI18n } from '@shopify/react-i18n';
import { Button } from '@shopify/polaris';

type Props = {
  stepNumber: number,
  totalSteps: number,
  nextStep: () => void
};

const Navigation = (props: Props) => {
  const { i18n, stepNumber, totalSteps, nextStep } = props;

  const isFinished = useMemo(() => {
    return stepNumber === totalSteps;
  }, [stepNumber, totalSteps]);

  return (
    <div className="Navigation__Container">
      <p>
        {i18n.translate('AdminHTML.StandardSearch.GuideTour.Pagination.content', {
          t1: stepNumber,
          t2: totalSteps
        })}
      </p>
      <Button primary onClick={nextStep}>
        {isFinished
          ? i18n.translate('AdminHTML.StandardSearch.Actions.finish')
          : i18n.translate('AdminHTML.StandardSearch.Actions.next')}
      </Button>
    </div>
  );
};

export default withI18n()(Navigation);
